const question = {
    lessThanTen: { point: [4] },
    betweenTenAndFifty: { point: [3] },
    betweenTwentyAndFifty: { point: [2] },
    moreThanFifty: { point: [1] },
};

export default question;
